<template>
	<div class="page">
		<!-- 图片 -->
		<el-image class="pbg" :src="require('@/static/icon1.jpg')"></el-image>
		<!-- 注册 -->
		<div class="regBox animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<div class="backPage jts" @click="link('/home')">返回网站首页</div>
			<div class="tips">已有账号<p @click="link('/login')">立即登录</p></div>
			<!-- 状态 -->
			<div class="status f-ct">
				<div class="item" :class="nowStatus==1?'a':''" :style="nowStatus>1?'border-top: 5px solid #A4CFFF;':''">
					<div class="nub">1</div>
					<div class="txt">注册协议</div>
				</div>
				<div class="item" @click="nowStatus=2" :class="nowStatus==2?'a':''" :style="nowStatus>2?'border-top: 5px solid #A4CFFF;':''">
					<div class="nub">2</div>
					<div class="txt">用户基本信息</div>
				</div>
				<div class="item" :class="nowStatus==3?'a':''" :style="nowStatus>3?'border-top: 5px solid #A4CFFF;':''">
					<div class="nub">3</div>
					<div class="txt">完善注册信息</div>
				</div>
				<div class="item" :class="nowStatus==4?'a':''" :style="nowStatus>4?'border-top: 5px solid #A4CFFF;':''">
					<div class="nub">4</div>
					<div class="txt">提交审核成功</div>
				</div>
			</div>
			<!-- 注册协议 -->
			<div class="regXy" v-show="nowStatus==1">
				<div class="tit">请您仔细阅读注册协议</div>
				<div class="txtBox">
					<div class="rivhBox" v-html="xieyiMsg.content"></div>
				</div>
				<div class="btnBox f-ct">
					<div @click="back()">不同意</div>
					<div @click="nowStatus=2">同意协议</div>
				</div>
			</div>
			<!-- 用户基本信息 -->
			<div class="userFrom" v-show="nowStatus==2">
				<div class="tit">用户基本信息</div>
				<div class="fromItm">
					<div class="name">选择注册身份<span> *</span></div>
					<div class="identity f-ct">
						<div class="itm f-ct" @click="userType=1" :class="userType==1?'a':''">
							<el-image v-if="userType==1" :src="require('@/static/icon3h.png')"></el-image>
							<el-image v-else :src="require('@/static/icon3.png')"></el-image>
							<p>学员用户</p>
						</div>
						<div class="itm f-ct" @click="userType=2" :class="userType==2?'a':''">
							<el-image v-if="userType==2" :src="require('@/static/icon4h.png')"></el-image>
							<el-image v-else :src="require('@/static/icon4.png')"></el-image>
							<p>企业用户</p>
						</div>
					</div>
				</div>
				<div class="fromItm">
					<div class="name">手机号码<span> *</span></div>
					<div class="iptBox">
						<el-input type="number" v-model="mobile" placeholder="请输入手机号码"></el-input>
					</div>
				</div>
				<div class="fromItm">
					<div class="name">验证码<span> *</span></div>
					<div class="iptBox codeBox f-ct">
						<el-input type="text" v-model="code" placeholder="请输入验证码"></el-input>
						<div class="codeTxt" @click="authMemberregCaptcha">{{codetxt}}</div>
					</div>
				</div>
				<div class="fromItm">
					<div class="name">登录密码<span> *</span></div>
					<div class="iptBox">
						<el-input type="password" v-model="password" placeholder="由6-16位的英文字母、数字组成"></el-input>
					</div>
				</div>
				<div class="fromItm">
					<div class="name">确认密码<span> *</span></div>
					<div class="iptBox">
						<el-input type="password" v-model="password1" placeholder="需与登录密码保持一致"></el-input>
					</div>
				</div>
				<div class="anniu" @click="fromF1">下一步</div>
			</div>
			<!-- 完善注册信息 学员 -->
			<div class="userMsg" v-show="nowStatus==3&&userType==1">
				<div class="tit">用户基本信息</div>
				<div class="fromItmW f-ct">
					<div class="fromItm">
						<div class="name">姓名<span> *</span></div>
						<div class="iptBox">
							<el-input type="text" v-model="xyFrom.name" placeholder="请输入真实姓名"></el-input>
						</div>
					</div>
					<div class="fromItm">
						<div class="name">性别<span> *</span></div>
						<div class="iptBox">
							<el-input type="text" disabled v-model="xyFrom.genderTxt" placeholder="可从身份证识别"></el-input>
						</div>
					</div>
				</div>
				<div class="fromItmW f-ct">
					<div class="fromItm">
						<div class="name">身份证号码<span> *</span></div>
						<div class="iptBox">
							<el-input type="text" @input="idcardF" v-model="xyFrom.identityCardCode" placeholder="请输入真实有效身份证号码"></el-input>
						</div>
					</div>
					<div class="fromItm">
						<div class="name">出生日期<span> *</span></div>
						<div class="iptBox">
							<el-input type="text" disabled v-model="xyFrom.birthday" placeholder="可从身份证识别"></el-input>
						</div>
					</div>
				</div>
				<div class="fromItmW f-ct">
					<div class="fromItm" style="width: 100%;">
						<div class="name">工作单位<span> *</span></div>
						<div class="iptBox">
							<el-input type="text" @input="companysearchCompany" v-model="dwTxt" placeholder="请输入您的工作单位"></el-input>
						</div>
					</div>
				</div>
				<div class="qyList" v-if="dwTxt&&!dwItem">
					<div class="zw" style="padding-top: 0;" v-if="!dwList.length">
						<el-image style="width: 1rem;" :src="require('@/static/zw.png')"></el-image>
						<p>未查询到工作单位信息，请输入正确的单位名称进行搜索，如未创建单位会员，请先联系本单位负责人或协会工作人员注册创建单位会员后，再进行个人会员注册。 </p>
					</div>
					<div class="itm" @click="selDWf(item)" v-for="(item,index) in dwList">
						<el-image :src="item.logo"></el-image>
						<p>
							<span :class="idx==1?'red':''" v-for="(itm,idx) in item.nameArr">{{itm}}</span>
						</p>
					</div>
				</div>
				<div class="gongsiMsg" v-if="dwItem">
					<div class="lable">企业信息</div>
					<div class="detail f-ct">
						<el-image :src="dwItem.logo"></el-image>
						<div class="r">
							<p class="name">{{dwItem.companyName}}</p>
							<p class="t1">企业联系人：{{dwItem.contact}}</p>
							<p class="t1">企 业 电 话：{{dwItem.mobile}}</p>
							<p class="t1">企 业 地 址：{{dwItem.provinceName}}{{dwItem.cityName}}{{dwItem.districtName}}{{dwItem.address}}</p>
						</div>
					</div>
				</div>
				<div class="fromItmW f-ct">
					<div class="fromItm">
						<div class="name">学历<span> *</span></div>
						<div class="iptBox">
							<el-select v-model="xyFrom.educationName" placeholder="请选择">
								<el-option
									v-for="item in optionsXL"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							<!-- <el-input type="text" v-model="xyFrom.educationName" placeholder="请输入您的学历"></el-input> -->
						</div>
					</div>
					<div class="fromItm">
						<div class="name">职称</div>
						<div class="iptBox">
							<el-select v-model="xyFrom.jobName" placeholder="请选择">
								<el-option
									v-for="item in optionsZC"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							<!-- <el-input type="text" v-model="xyFrom.jobName" placeholder="请输入您的职称"></el-input> -->
						</div>
					</div>
				</div>
				<div class="fromItmW f-ct">
					<div class="fromItm">
						<div class="name">职务</div>
						<div class="iptBox">
							<el-select v-model="xyFrom.positionName" placeholder="请选择">
								<el-option
									v-for="item in optionsZW"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
							<!-- <el-input type="text" v-model="xyFrom.positionName" placeholder="请输入您的职务"></el-input> -->
						</div>
					</div>
					<div class="fromItm">
						<div class="name">申请类别<span> *</span></div>
						<div class="iptBox" v-if="catArr.length">
							<el-cascader
							style="width: 100%;"
							placeholder="请选择您的申请类别"
							:props="{children:'childList',label:'categoryName',value:'id'}"
							v-model="catVar"
							:options="catArr"></el-cascader>
						</div>
					</div>
				</div>
				<div class="fromItmImg">
					<div class="name">个人照片<span class="redxin"> *</span><span class="red">请上传1寸免冠白底证件照，否则将影响证书办理！</span></div>
					<el-upload accept="image/png, image/jpeg" 
					class="avatar-uploader"
					:action="uplink"
					:show-file-list="false"
					:on-change="touxiangF">
						<el-image v-if="!portrait" :src="require('@/static/icon7.png')"></el-image>
						<el-image v-else :src="portrait"></el-image>
					</el-upload>
				</div>
				<div class="fromItmImg">
					<div class="name">身份证扫描件<span class="redxin"> *</span><span class="hui">请上传身份证正反面扫描件(仅支持上传JPG、PNG格式，大小为500KB以内)</span></div>
					<div class="f-ct">
						<el-upload accept="image/png, image/jpeg" 
						class="avatar-uploader"
						:action="uplink"
						:show-file-list="false"
						:on-change="idCardF1">
							<el-image v-if="!identityCardFrontImage" :src="require('@/static/icon8.png')"></el-image>
							<el-image v-else :src="identityCardFrontImage"></el-image>
						</el-upload>
						<el-upload accept="image/png, image/jpeg" 
						class="avatar-uploader"
						:action="uplink"
						:show-file-list="false"
						:on-change="idCardF2">
							<el-image v-if="!identityCardBackImage" :src="require('@/static/icon9.png')"></el-image>
							<el-image v-else :src="identityCardBackImage"></el-image>
						</el-upload>
					</div>
				</div>
				<div class="fromItmImg">
					<div class="name">毕业证扫描件<span class="hui">请上传毕业证扫描件(仅支持上传JPG、PNG格式，大小为500KB以内)</span></div>
					<div class="f-ct">
						<el-upload accept="image/png, image/jpeg" 
						class="avatar-uploader"
						:action="uplink"
						:show-file-list="false"
						:on-change="byzimgF">
							<el-image v-if="!diplomaImage" :src="require('@/static/icon7.png')"></el-image>
							<el-image v-else :src="diplomaImage"></el-image>
						</el-upload>
					</div>
				</div>
				<div class="fromItmImg">
					<div class="name">劳动合同<span class="redxin"> *</span><span class="hui">请上传劳动合同扫描件(仅支持上传JPG、PNG格式，大小为500KB以内)</span></div>
					<div class="f-ct" style="margin-top: 6px;">
						<!-- <el-upload accept="image/png, image/jpeg" 
						class="avatar-uploader"
						:action="uplink"
						list-type="picture-card"
						:show-file-list="false"
						:on-change="ldhtimgF">
							<div class="f-ct">
								<el-image v-if="!laborContractImage" :src="require('@/static/icon10.png')"></el-image>
								<el-image v-else :src="laborContractImage"></el-image>
								<el-image :src="require('@/static/icon10.png')"></el-image>
								<el-image :src="require('@/static/icon10.png')"></el-image>
								<el-image :src="require('@/static/icon10.png')"></el-image>
								<el-image :src="require('@/static/icon10.png')"></el-image>
								<el-image :src="require('@/static/icon10.png')"></el-image>
								<el-image :src="require('@/static/icon10.png')"></el-image>
							</div>
						</el-upload> -->
						<el-upload accept="image/png, image/jpeg" 
						:action="uplink"
						list-type="picture-card"
						:on-preview="handlePictureCardPreview"
						:on-success="ldhtimgF"
						:on-remove="handleRemove">
						<!-- <i class="el-icon-plus"></i> -->
						<el-image :src="require('@/static/icon10.png')"></el-image>
						</el-upload>
						<!-- <el-dialog :visible.sync="dialogVisible">
						  <img width="100%" :src="require('@/static/icon10.png')" alt="">
						</el-dialog> -->
					</div>
				</div>
				<div class="fromItmImg">
					<div class="name">社保缴纳证明扫描件<span class="redxin"> *</span><span class="hui">请上传社保缴纳证明扫描件(仅支持上传JPG、PNG格式，大小为500KB以内)</span></div>
					<div class="f-ct">
						<el-upload accept="image/png, image/jpeg" 
						class="avatar-uploader"
						:action="uplink"
						:show-file-list="false"
						:on-change="shebaoImgf">
							<el-image v-if="!socialSecurityImage" :src="require('@/static/icon7.png')"></el-image>
							<el-image v-else :src="socialSecurityImage"></el-image>
						</el-upload>
					</div>
				</div>
				<div class="fromItmImg">
					<div class="name">体检报告照片<span class="hui">请上传社保缴纳证明扫描件(仅支持上传JPG、PNG格式，大小为500KB以内)</span></div>
					<div class="f-ct">
						<el-upload accept="image/png, image/jpeg" 
						class="avatar-uploader"
						:action="uplink"
						:show-file-list="false"
						:on-change="tjImgf">
							<el-image v-if="!physicalImage" :src="require('@/static/icon7.png')"></el-image>
							<el-image v-else :src="physicalImage"></el-image>
						</el-upload>
					</div>
				</div>
				<div class="fromItmW f-ct">
					<div class="fromItm" style="width: 100%;">
						<div class="name">个人健康承诺</div>
						<div class="iptBox">
							<el-input type="textarea" value="本人身体健康，无妨碍从事相应燃气作业的疾病和生理缺陷。本人对以上信息的真实性负责，如有隐瞒，相关责任全部由本人承担。" placeholder="请输入您的工作单位"></el-input>
						</div>
					</div>
				</div>
				<div class="anniu" @click="fromF2QM">提交资料</div>
			</div>
			<!-- 完善注册信息 企业 -->
			<div class="userMsg" v-show="nowStatus==3&&userType==2">
				<div class="tit">用户基本信息</div>
				<div class="fromItmW f-ct">
					<div class="fromItm">
						<div class="name">企业名称<span> *</span></div>
						<div class="iptBox">
							<el-input type="text" v-model="qyFrom.companyName" placeholder="请输入企业全称"></el-input>
						</div>
					</div>
					<div class="fromItm">
						<div class="name">统一社会信用代码<span> *</span></div>
						<div class="iptBox">
							<el-input type="text" v-model="qyFrom.companyCreditCode" placeholder="请输入统一社会信用代码"></el-input>
						</div>
					</div>
					
				</div>
				<div class="fromItmW f-ct">
					<div class="fromItm">
						<div class="name">企业联系人<span> *</span></div>
						<div class="iptBox">
							<el-input type="text" v-model="qyFrom.contact" placeholder="请输入企业联系人"></el-input>
						</div>
					</div>
					<div class="fromItm">
						<div class="name">银行账号</div>
						<div class="iptBox">
							<el-input type="text" v-model="qyFrom.bankAccount" placeholder="请输入银行账号"></el-input>
						</div>
					</div>
				</div>
				<div class="fromItmW f-ct">
					<div class="fromItm" style="width: 100%;">
						<div class="name">开户行</div>
						<div class="iptBox">
							<el-input type="text" v-model="qyFrom.openingBank" placeholder="请输入开户银行全称，方便开票处理"></el-input>
						</div>
					</div>
				</div>
				<div class="fromItmW f-ct">
					<div class="addr">
						<div class="name">企业地址<span> *</span></div>
						<div class="iptBox" v-if="regionList.length">
							<el-cascader
							style="width: 100%;"
							placeholder="请选择企业地址"
							:props="{children:'childList',label:'name',value:'id'}"
							v-model="regionVal"
							:options="regionList"></el-cascader>
						</div>
						<!-- <div class="selAddr f-ct">
							<div class="selAddrItm">
								<el-select v-model="value" placeholder="请选择">
									<el-option
										v-for="item in options"
										:key="item.value"
										:label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
							<div class="selAddrItm">
								<el-select v-model="value" placeholder="请选择">
									<el-option
										v-for="item in options"
										:key="item.value"
										:label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
							<div class="selAddrItm">
								<el-select v-model="value" placeholder="请选择">
									<el-option
										v-for="item in options"
										:key="item.value"
										:label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</div>
						</div> -->
					</div>
					<div class="fromItm">
						<div class="name" style="opacity: 0;">详细地址</div>
						<div class="iptBox">
							<el-input type="text" v-model="qyFrom.address" placeholder="请输入详细地址信息"></el-input>
						</div>
					</div>
				</div>
				<div class="fromItmImg">
					<div class="name">企业logo<span class="redxin"> *</span><span class="hui">企业LOGO的尺寸大小建议为160px*120px，文件格式为jpg或jpeg的图片</span></div>
					<div class="f-ct">
						<el-upload accept="image/png, image/jpeg" 
						class="avatar-uploader"
						:action="uplink"
						:show-file-list="false"
						:on-change="qylogoimgF">
							<el-image v-if="!logo" :src="require('@/static/icon7.png')"></el-image>
							<el-image v-else :src="logo"></el-image>
						</el-upload>
					</div>
				</div>
				<div class="fromItmImg">
					<div class="name">营业执照扫描件<span class="redxin"> *</span><span class="hui">企业名称必须与单位营业执照中的名称一致，(仅支持上传JPG、PNG格式)</span></div>
					<div class="f-ct">
						<el-upload accept="image/png, image/jpeg" 
						class="avatar-uploader"
						:action="uplink"
						:show-file-list="false"
						:on-change="qyyyzzimgF">
							<el-image v-if="!businessLicenseImage" :src="require('@/static/icon7.png')"></el-image>
							<el-image v-else :src="businessLicenseImage"></el-image>
						</el-upload>
					</div>
				</div>
				<div class="anniu" @click="fromF3">提交资料</div>
			</div>
			<!-- 提交审核成功 -->
			<div class="fromSuss" v-show="nowStatus==4">
				<div class="tit f-ct">
					<el-image :src="require('@/static/icon12.png')"></el-image>
					<p>{{mobileSuss}}&emsp;恭喜您注册成功</p>
					<p style="font-size: 0.14rem;color: #999;margin-top: 0.1rem;text-align: center;width: 100%;">您已注册成功，资料待审核中，审核通过后方可开始报名。</p>
				</div>
				<div class="anniu" @click="link('/login')">去登陆</div>
				<div class="ma">
					<p>您还可以扫码关注平台微信公众号，及时了解最新培训注册动态信息</p>
					<el-image :src="require('@/static/downimg1.jpg')"></el-image>
				</div>
			</div>
		</div>
		
		<!-- 弹出框 -->
		<div class="maskBg" @click="hbQianmin=false" v-if="hbQianmin"></div>
		<div class="subTips" v-if="hbQianmin">
			<div class="hbTit f-bct">
				<p>签名</p>
				<el-image class="cha" @click="hbQianmin=false" :src="require('@/static/icon57.png')"></el-image>
			</div>
			<!-- <div class="qianMin">
				<vue-esign
				ref="esign"
				style="border: 1px dashed #c2c1c1;"
				:height="360"
				/>
			</div> -->
			<div class="qianMin">
				<vue-esign
				ref="esign"
				style="border: 1px dashed #c2c1c1;"
				:height="360"
				/>
			</div>
			<!-- <div class="qianMin" v-if="signatureImage">
				<el-image :src="signatureImage"></el-image>
			</div> -->
			<div class="t1">提示：请用在虚线内签名</div>
			<div class="hbbtnBox f-ct">
				<div class="b1" @click="signatureImage='',handleReset()">重写</div>
				<div class="b2" @click="handleGenerate">确定</div>
			</div>
		</div>
		<!-- 底部文字 -->
		<div class="baTxt">Copright @2017 Corporation AII Rights Reservde 琼ICP备18003071号-2 海南省燃气协会网支持IPv6网络</div>
	</div>
</template>
<script>
import { articledetail,
authMemberregCaptcha,
coursecategoryList,
companysearchCompany,
authMemberregister,
regioncityTree,
authCompanyregister
} from "/src/api/api.js"
import axios from "axios";
import vueEsign from 'vue-esign'
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
let ic;
var nub = 120;
export default {
	components: { vueEsign },
	data(){
		return {
			userType:1,
			nowStatus:1,
			hbQianmin:false,
			cnTxt:'本人身体健康，无妨碍从事相应燃气作业的疾病和生理缺陷。本人对以上信息的真实性负责，如有隐瞒，相关责任全部由本人承担。',
			signatureImage:'',
			// 协议
			xieyiMsg:'',
			// 表单 用户基本信息
			codetxt:'发送验证码',
			mobile:'',
			mobileSuss:'',
			code:'',
			password:'',
			password1:'',
			// 表单 学员
			xyFrom:{
				name:'',
				gender:'',
				genderTxt:'',
				birthday:'',
				identityCardCode:'',
				educationName:'',
				jobName:'',
				positionName:'',
			},
			// 工作单位
			dwTxt:'',
			dwList:'',
			dwItem:'',
			// 申请类别
			catArr:[],
			catVar:'',
			// 上传图
			portrait:'',
			identityCardFrontImage:'',
			identityCardBackImage:'',
			diplomaImage:'',
			laborContractImage:[],
			socialSecurityImage:'',
			physicalImage:'',
			dialogImageUrl: '',
			dialogVisible: false,
			// 表单 企业
			qyFrom:{
				companyName:'',
				companyCreditCode:'',
				contact:'',
				bankAccount:'',
				openingBank:'',
				address:'',
			},
			// 地址
			regionList:[],
			regionVal:'',
			// 上传图
			logo:'',
			businessLicenseImage:'',

			
			// 学历
			optionsXL: [
				{value: '小学',label: '小学'},
				{value: '初中',label: '初中'},
				{value: '高中',label: '高中'},
				{value: '专科',label: '专科'},
				{value: '本科',label: '本科'},
				{value: '硕士研究生',label: '硕士研究生'},
				{value: '博士研究生',label: '博士研究生'},
			],
			// valueXL: '小学',
			// 职称
			optionsZC: [
				{value: '正高级工程师',label: '正高级工程师'},
				{value: '高级工程师',label: '高级工程师'},
				{value: '工程师',label: '工程师'},
				{value: '助理工程师',label: '助理工程师'},
				{value: '技术员',label: '技术员'},
				{value: '无',label: '无'},
			],
			// valueZC: '技术员',
			// 职务
			optionsZW: [
				{value: '总裁',label: '总裁'},
				{value: '副总裁',label: '副总裁'},
				{value: '总裁助理',label: '总裁助理'},
				{value: '总经理',label: '总经理'},
				{value: '副总经理',label: '副总经理'},
				{value: '总经理助理',label: '总经理助理'},
				{value: '经理/站长',label: '经理/站长'},
				{value: '安全员',label: '安全员'},
				{value: '班组长',label: '班组长'},
				{value: '普通员工',label: '普通员工'},
			],
			// valueZW: '普通员工',
			
			isZC:false,
		}
	},
	mounted() {
		this.articledetail()
		this.coursecategoryList()
		this.regioncityTree()
	},
	methods:{
		// 基础信息 下一步
		fromF1(){
			if(!this.checkModbile(this.mobile)){
				this.Tips('请输入正确的手机号','error')
				return
			}
			if(!this.code){this.Tips('请输入验证码','error');return}
			if(!this.password){this.Tips('请输入密码','error');return}
			if(!this.password1){this.Tips('请再次输入密码','error');return}
			
			if(this.password==this.password1){
				this.nowStatus=3
			}else{this.Tips('两次密码输入不一致','error')}
		},
		// 完善注册信息 企业 下一步
		async fromF3(){
			if(!this.qyFrom.companyName){this.Tips('请输入企业全称','error');return}
			if(!this.qyFrom.companyCreditCode){this.Tips('请输入统一社会信用代码','error');return}
			if(!this.qyFrom.contact){this.Tips('请输入企业联系人','error');return}
			// if(!this.qyFrom.bankAccount){this.Tips('请输入银行账号','error');return}
			// if(!this.qyFrom.openingBank){this.Tips('请输入开户银行全称，方便开票处理','error');return}
			if(!this.regionVal){this.Tips('请选择企业地址','error');return}
			if(!this.qyFrom.address){this.Tips('请输入详细地址信息','error');return}
			if(!this.logo){this.Tips('请上传企业logo','error');return}
			if(!this.businessLicenseImage){this.Tips('请上传营业执照扫描件','error');return}
			var data = {
				mobile:this.mobile,
				code:this.code,
				password:this.password,
				...this.qyFrom,
				provinceId:this.regionVal[0],
				cityId:this.regionVal[1],
				districtId:this.regionVal[2],
				logo:this.logo,
				businessLicenseImage:this.businessLicenseImage,
			}
			let res = await authCompanyregister(data);
			if(res.code==200){
				this.Tips('注册成功','success')
				setTimeout(()=>{
					this.mobileSuss = this.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
					this.nowStatus = 4
				},1500)
			}else{this.Tips(res.msg,'error')}
		},
		// 完善注册信息 普通 下一步
		fromF2QM(){
			if(!this.xyFrom.name){this.Tips('请输入真实姓名','error');return}
			if(!this.isCardNo(this.xyFrom.identityCardCode)){this.Tips('请输入真实有效身份证号码','error');return}
			if(!this.dwItem){this.Tips('请选择工作单位','error');return}
			if(!this.xyFrom.educationName){this.Tips('请输入您的学历','error');return}
			if(!this.xyFrom.jobName){this.Tips('请输入您的职称','error');return}
			if(!this.xyFrom.positionName){this.Tips('请输入您的职务','error');return}
			if(!this.catVar){this.Tips('请选择您的申请类别','error');return}
			if(!this.portrait){this.Tips('请上传个人照片','error');return}
			if(!this.identityCardFrontImage){this.Tips('请上传身份证正面扫描件','error');return}
			if(!this.identityCardBackImage){this.Tips('请上传身份证反面扫描件','error');return}
			// if(!this.diplomaImage){this.Tips('请上传毕业证扫描件','error');return}
			if(this.socialSecurityImage||this.laborContractImage.length){}else{
				if(!this.laborContractImage.length){this.Tips('请上传劳动合同扫描件','error');return}
				if(!this.socialSecurityImage){this.Tips('请上传社保缴纳证明扫描件','error');return}
			}
			this.hbQianmin = true
		},
		async fromF2(){
			if(this.isZC){return}
			this.isZC = true
			var data = {
				mobile:this.mobile,
				code:this.code,
				password:this.password,
				...this.xyFrom,
				companyId:this.dwItem.id,
				courseCategoryId:this.catVar[1],
				portrait:this.portrait,
				identityCardFrontImage:this.identityCardFrontImage,
				identityCardBackImage:this.identityCardBackImage,
				diplomaImage:this.diplomaImage,
				laborContractImage:this.laborContractImage,
				socialSecurityImage:this.socialSecurityImage,
				physicalImage:this.physicalImage,
				signatureImage:this.signatureImage,
			}
			let res = await authMemberregister(data);
			if(res.code==200){
				this.Tips('注册成功','success')
				setTimeout(()=>{
					this.hbQianmin=false
					this.mobileSuss = this.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
					this.nowStatus = 4
					this.isZC = false
				},1500)
			}else{this.Tips(res.msg,'error');this.isZC = false}
		},
		// 上传头像
		touxiangF(file) {
			if(file.response){
				this.portrait = file.response.data.url;
			}
		},
		// 身份证正面
		idCardF1(file) {
			if(file.response){
				this.identityCardFrontImage = file.response.data.url;
			}
		},
		// 身份证反面
		idCardF2(file) {
			if(file.response){
				this.identityCardBackImage = file.response.data.url;
			}
		},
		// 毕业证照片
		byzimgF(file) {
			if(file.response){
				this.diplomaImage = file.response.data.url;
			}
		},
		// 劳动合同 照片
		ldhtimgF(response,file,fileList) {
			if(response.code==200){
				this.laborContractImage.push(response.data.url)
			}else{
				this.Tips(response.msg,'error');
				let index = 0;
				for(const i in fileList){
					if(fileList[i]==file){
						index=i;
						break;
					}
				}
				fileList.splice(index,1);
			}
		},
		handleRemove(file, fileList) {
			// console.log(fileList);
			var laborContractImage = []
			fileList.forEach((item)=>{
				laborContractImage.push(item.response.data.url)
			})
			this.laborContractImage = laborContractImage
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		// 社保 照片
		shebaoImgf(file) {
			if(file.response){
				this.socialSecurityImage = file.response.data.url;
			}
		},
		tjImgf(file) {
			if(file.response){
				this.physicalImage = file.response.data.url;
			}
		},
		// 企业LOGO 照片
		qylogoimgF(file) {
			if(file.response){
				this.logo = file.response.data.url;
			}
		},
		// 营业执照 照片
		qyyyzzimgF(file) {
			if(file.response){
				this.businessLicenseImage = file.response.data.url;
			}
		},
		// 搜索企业信息
		async companysearchCompany(){
			this.dwItem = ''
			let res = await companysearchCompany({companyName:this.dwTxt});
			if(res.code==200){
				// var arr = []
				res.data.forEach((item)=>{
					var arr = item.companyName.split(this.dwTxt)
					arr.splice(1,0,this.dwTxt)
					item.nameArr = arr
				})
				this.dwList = res.data
			}else{this.Tips(res.msg,'error')}
		},
		selDWf(item){
			this.dwItem = item
			this.dwTxt = item.companyName
			this.dwList = []
		},
		// 获取tree结构的列表
		async regioncityTree(){
			let res = await regioncityTree({});
			if(res.code==200){
				this.regionList = res.data
			}else{this.Tips(res.msg,'error')}
		},
		// 获取课程分类
		async coursecategoryList(){
			let res = await coursecategoryList({});
			if(res.code==200){
				var catIdx = []
				// res.data.categoryList.forEach((item)=>{
				// 	item.childList = [{
				// 		id:item.id,
				// 		categoryName:'全部',
				// 	},...item.childList]
				// })
				for(var i in res.data.categoryList){
					for(var j in res.data.categoryList[i].childList){
						delete res.data.categoryList[i].childList[j]['childList'];
					}
				}
				this.catArr = res.data.categoryList
			}else{this.Tips(res.msg,'error')}
		},
		// 文章详情
		async articledetail(){
			let res = await articledetail({id:190});
			if(res.code==200){
				this.xieyiMsg = res.data
			}else{this.Tips(res.msg,'error')}
		},
		// 验证码
		async authMemberregCaptcha(){
			var that = this
			if(!this.checkModbile(this.mobile)){
				this.Tips('请输入正确的手机号','error')
				return
			}
			let res = await authMemberregCaptcha({mobile:this.mobile});
			if(res.code==200){
				this.Tips(res.msg,'success')
				nub = 120
				ic = setInterval(()=>{
					nub--
					that.codetxt = nub+'s'
					if(nub<=0){
						that.codetxt = '发送验证码'
						clearInterval(ic)
					}
				},1000)
			}else{this.Tips(res.msg,'error')}
		},
		checkModbile(mobile) {
			var re = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
			var result = re.test(mobile); 
			if(!result) {
				return false;//若手机号码格式不正确则返回false
				}
			return true;
		},
		idcardF(){
			this.xyFrom.birthday = this.idCard(this.xyFrom.identityCardCode,1)
			this.xyFrom.genderTxt = this.idCard(this.xyFrom.identityCardCode,2)
			this.xyFrom.gender = this.idCard(this.xyFrom.identityCardCode,4)
		},
		//通过身份证号计算年龄、性别、出生日期
		idCard(userCard, num) {
			//获取出生日期
			var birth ;
			if (num == 1) {
				birth = userCard.substring(6, 10) + "-" + userCard.substring(10, 12) + "-" + userCard.substring(12, 14);
				return birth;
			}
			//获取性别
			if (num == 2) {
				if (parseInt(userCard.substr(16, 1)) % 2 == 1) {
					return "男";
				} else {
					return "女";
				}
			}
			if (num == 4) {
				if (parseInt(userCard.substr(16, 1)) % 2 == 1) {
					return "1";
				} else {
					return "2";
				}
			}
			//获取年龄
			if (num == 3) {
				var myDate = new Date();
				var month = myDate.getMonth() + 1;
				var day = myDate.getDate();
				var age = myDate.getFullYear() - userCard.substring(6, 10) - 1;
				if (userCard.substring(10, 12) < month || userCard.substring(10, 12) == month && userCard.substring(12, 14) <= day) {
					age++;
				}
				return age;
			}
		},
		isCardNo(card){
			// 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
			var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
			if(reg.test(card) === false){
				// alert("身份证输入不合法");
				return  false;
			}else{
				return true
			}
		},
		// 签名部分
		//清空画板..
		handleReset() {
			this.$refs.esign.reset();
			this.resultImg = "";
		},
		//生成签名图片..
		handleGenerate() {
			if(this.signatureImage){
				this.fromF2()
				return
			}
			this.$refs.esign.generate().then(res => {
				let fileName = "img1.png";
				let file = this.dataURLtoFile(res, fileName);
				console.log("file", file);
				this.upImg(file)
			}).catch(err => {
				this.Tips('请先签名','error')
				// alert(err) // 画布没有签字时会执行这里 'Not Signned'
			})
		},
		async upImg(file){
			var that = this
			try {
				const response = await axios.post(this.uplink, {file}, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				});
				// this.uploadStatus = '上传成功！';
				this.signatureImage = response.data.data.url; // 假设API返回图片URL
				that.fromF2()
			} catch (error) {
				// console.error('上传失败:', error);
				// this.uploadStatus = '上传失败: ' + (error.response?.data?.message || error.message);
			}
		},
		//将图片base64转换为文件
		dataURLtoFile(dataurl, filename) {
			var arr = dataurl.split(","),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new File([u8arr], filename, { type: mime });
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
	// padding-top: 140px;
	// padding-bottom: 140px;
	// padding-top: 60px;
}
</style>
<style lang="scss" scoped>
.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.page{
	position: relative;
	padding-bottom: 140px;
	padding-top: 60px;
}
.pbg{
	width: 1920px;
	height: 1080px;
	display: block!important;
	position: fixed;
	top: 0;
	left: 0;
}
.regBox{
	// position: fixed;
	// top: 50%;
	// left: 50%;
	// transform: translateY(-50%)translateX(-50%);
	position: relative;
	z-index: 3;
	margin: auto;
	// margin-top: 60px;
	background: #fff;
	width: 1000px;
	// min-height: 810px;
	padding-bottom: 38px;
	.backPage{
		position: absolute;
		left: 4px;
		top: -32px;
		color: #3B6492;
		text-decoration: underline;
		font-size: 14px;
	}
	.tips{
		font-size: 14px;
		text-align: center;
		
		position: absolute;
		right: 4px;
		top: -32px;
		p{
			color: #3B6492;
			padding-left: 4px;
			display: inline-block;
			cursor: pointer;
		}
	}
	.status{
		height: 120px;
		.item{
			width: 25%;
			height: 100%;
			padding-top: 24px;
			// border-top: 5px solid #3B6492;
			cursor: pointer;
			border-top: 5px solid #F5F9FF;
			background: #F5F9FF;
			.nub{
				width: 30px;
				height: 30px;
				text-align: center;
				line-height: 30px;
				border-radius: 50%;
				margin: auto;
				color: #fff;
				font-size: 16px;
				background: #C9DDEF;
			}
			.txt{
				font-size: 16px;
				margin-top: 12px;
				text-align: center;
				color: #7A8B99;
			}
		}
		.a{
			border-top: 5px solid #3B6492;
			.nub{
				background: #3B6492;
			}
			.txt{
				color: #3B6492;
			}
		}
	}
	.regXy{
		.tit{
			font-size: 24px;
			color: #333333;
			text-align: center;
			padding-top: 34px;
			padding-bottom: 24px;
		}
		.txtBox{
			width: 900px;
			margin: auto;
			height: 460px;
			padding: 22px;
			background: #F7F9FA;
			.rivhBox{
				width: 100%;
				height: 100%;
				font-size: 14px;
				color: #545964;
				overflow-y: scroll;
			}
		}
		.btnBox{
			justify-content: flex-end;
			width: 900px;
			margin: auto;
			margin-top: 28px;
			div{
				width: 182px;
				height: 40px;
				text-align: center;
				line-height: 40px;
				font-size: 16px;
				color: #898989;
				background: #EEEEEE;
				cursor: pointer;
				&:last-child{
					margin-left: 16px;
					color: #fff;
					background: #3B6492;
				}
			}
		}
	}
	.userFrom{
		// background: #fff;
		.tit{
			font-size: 24px;
			color: #333333;
			text-align: center;
			padding-top: 34px;
			padding-bottom: 40px;
		}
		.fromItm{
			width: 350px;
			margin: auto;
			margin-bottom: 24px;
			.name{
				color: #666666;
				font-size: 14px;
				padding-bottom: 6px;
				span{
					color: #FF5F5A;
				}
			}
			.codeBox{
				.el-input{
					width: calc(100% - 96px)!important;
				}
			}
			.iptBox{
				border: 1px solid #DDDDDD;
				padding-right: 6px;
				.el-input{
					width: calc(100% - 0px);
				}
				::v-deep .el-input__inner{
					height: 40px;
					border: none;
					background: transparent;
				}
				.codeTxt{
					width: 96px;
					height: 28px;
					line-height: 28px;
					text-align: center;
					font-size: 14px;
					color: #fff;
					background: #3B6492;
					cursor: pointer;
				}
			}
			.identity{
				display: flex;
				justify-content: space-between;align-items: center;
				margin: auto;
				margin-bottom: 20px;
				width: 350px;
				.itm{
					width: 170px;
					height: 72px;
					justify-content: center;
					border: 1px solid #DEDEDE;
					cursor: pointer;
					.el-image{
						width: 40px;
						height: 40px;
						margin-right: 12px;
					}
					text{
						font-size: 14px;
						color: #666666;
					}
				}
				.a{
					border: 1px solid #3B6492;
					text{
						color: #3B6492;
					}
				}
			}
		}
		.anniu{
			margin: auto;
			width: 182px;
			height: 40px;
			text-align: center;
			line-height: 40px;
			font-size: 16px;
			color: #fff;
			background: #3B6492;
			cursor: pointer;
			margin-top: 34px;
		}
	}
	.userMsg{
		.tit{
			font-size: 24px;
			color: #333333;
			text-align: center;
			padding-top: 34px;
			padding-bottom: 40px;
		}
		.fromItmW{
			width: 750px;
			margin: auto;
			margin-bottom: 20px;
			justify-content: space-between;
			.addr{
				width: 350px;
				.name{
					color: #666666;
					font-size: 14px;
					padding-bottom: 6px;
					span{
						color: #FF5F5A;
					}
				}
				.selAddr{
					.selAddrItm{
						width: 108px;
						border: 1px solid #DDDDDD;
						margin-right: 13px;
						&:last-child{
							margin-right: 0;
						}
						.el-select{
							width: 100%;
						}
						::v-deep .el-input__inner{
							height: 40px;
							border: none;
							background: transparent;
						}
					}
				}
			}
			.fromItm{
				width: 350px;
				.name{
					color: #666666;
					font-size: 14px;
					padding-bottom: 6px;
					span{
						color: #FF5F5A;
					}
				}
				.codeBox{
					.el-input{
						width: calc(100% - 96px);
					}
				}
				.iptBox{
					border: 1px solid #DDDDDD;
					padding-right: 6px;
					.el-input{
						width: calc(100% - 0px);
					}
					.el-select{
						width: 100%;
					}
					::v-deep .el-input__inner{
						height: 40px;
						border: none;
						background: transparent;
					}
					.el-textarea{
						width: 100%;
						height: 140px;
					}
					::v-deep .el-textarea__inner{
						border: none;
						height: 140px;
						background: transparent;
						padding-top: 16px;
					}
					.codeTxt{
						width: 96px;
						height: 28px;
						line-height: 28px;
						text-align: center;
						font-size: 14px;
						color: #fff;
						background: #3B6492;
						cursor: pointer;
					}
				}
			}
		}
		.fromItmImg{
			width: 750px;
			margin: auto;
			margin-bottom: 20px;
			.name{
				color: #666666;
				font-size: 14px;
				.red{
					padding-left: 10px;
					color: #FF5F5A;
				}
				.redxin{color: #FF5F5A;}
				.hui{
					padding-left: 10px;
					color: #99999999;
				}
			}
			::v-deep .el-upload{
				width: 108px;
				height: 108px;
				border: none;
			}
			::v-deep .el-upload-list__item{
				width: 108px;
				height: 108px;
			}
			.avatar-uploader{
				// width: 108px;
				// height: 108px;
				margin-top: 6px;
				margin-right: 16px;
				.el-image{
					width: 108px;
					height: 108px;
					margin-right: 10px;
					margin-bottom: 10px;
				}
			}
		}
		.anniu{
			margin: auto;
			width: 182px;
			height: 40px;
			text-align: center;
			line-height: 40px;
			font-size: 16px;
			color: #fff;
			background: #3B6492;
			cursor: pointer;
			margin-top: 34px;
		}
	}
	.fromSuss{
		.tit{
			padding-top: 78px;
			justify-content: center;
			.el-image{
				width: 30px;
				height: 30px;
				margin-right: 14px;
			}
			p{
				font-size: 24px;
				color: #333333;
			}
		}
		.anniu{
			margin: auto;
			width: 182px;
			height: 40px;
			text-align: center;
			line-height: 40px;
			font-size: 16px;
			color: #fff;
			background: #3B6492;
			cursor: pointer;
			margin-top: 34px;
			margin-bottom: 70px;
		}
		.ma{
			width: 684px;
			margin: auto;
			padding-top: 52px;
			border-top: 1px solid #DDDDDD;
			p{
				text-align: center;
				font-size: 16px;
				color: #545964;
			}
			.el-image{
				margin: auto;
				display: block;
				width: 188px;
				height: 188px;
				margin-top: 30px;
			}
		}
	}
}
.gongsiMsg{
	width: 750px;
	background: #F5F8FF;
	margin: auto;
	padding: 0 12px;
	margin-bottom: 24px;
	padding-bottom: 16px;
	border: 1px solid #E5E5E5;
	.lable{
		font-size: 16px;
		color: #3B3C3E;
		font-weight: bold;
		padding-top: 12px;
		padding-bottom: 12px;
		span{
			font-size: 14px;
			color: #969696;
			font-weight: normal;
		}
	}
	.detail{
		.el-image{
			width: 134px;
			height: 134px;
			border-radius: 6px;
			margin-right: 17px;
		}
		.r{
			width: calc(100% - 151px);
			.name{
				font-size: 18px;
				color: #3B3C3E;
				margin-bottom: 12px;
				font-weight: bold;
			}
			.t1{
				font-size: 16px;
				color: #3B3C3E;
				margin-bottom: 6px;
			}
		}
	}
}
.qyList{
	width: 750px;
	max-height: 260px;
	overflow-y: scroll;
	margin: auto;
	margin-top: -10px;
	padding: 0 20px;
	padding-top: 20px;
	margin-bottom: 24px;
	background: #F5F8FF;
	border: 1px solid #E5E5E5;
	.itm{
		display: flex;
		align-items: center;
		padding-bottom: 20px;
		cursor: pointer;
		.el-image{
			width: 28px;
			height: 28px;
			border-radius: 50%;
			border: 1px solid #DBECFF;
			margin-right: 18px;
		}
		p{
			color: #666666;
			font-size: 14px;
			.red{
				color: #FF5F5A;
			}
			&:hover{
				color: #3B6492!important;
			}
		}
	}
}

.subTips{
	position: fixed;
	width: 662px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.hbTit{
		width: 662px;
		height: 69px;
		padding-left: 30px;
		padding-right: 32px;
		background: #FAFBFC;
		border-radius: 8px 8px 0 0;
		p{
			font-size: 18px;
			color: #2F3541;
		}
		.cha{
			width: 14px;
			height: 14px;
		}
	}
	.qianMin{
		width: 598px;
		// height: 270px;
		border: 1px dashed #D9D9D9;
		border-radius: 11px;
		margin: auto;
		margin-top: 32px;
	}
	.t1{
		font-size: 16px;
		color: #333333;
		padding-left: 40px;
		margin-top: 18px;
	}
	.hbbtnBox{
		margin-top: 28px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b2{
			background: #3B6492;
			color: #fff;
			margin-left: 14px;
		}
	}
}
</style>